







































































































































import { Component, Vue } from "vue-property-decorator";
import { GetNewsTems } from "@/request/common";
import BatchPrinting from "@/components/batch-printing.vue";
import { upsertZhuanbingModule } from "./zhuanbing-content.service";

@Component({
  components: {
    BatchPrinting,
  },
})
export default class EditZhuanbingBianzheng extends Vue {
  private shemianmai: any = {
    she: null,
    shexia: null,
    mian: null,
    mai: null,
  };
  private mainSymptoms: string[] = [
    "神疲乏力，精神不振；或眩晕耳鸣，形体浮肿",
    "容易感冒，或久咳不止，咯痰清稀，气促，或气短而喘",
    "食欲不振，食少纳差，腹胀，便溏；或腰膝酸软、夜尿频多",
    "纳呆乏味，食少腹胀",
    "泄泻，或五更泻，或久泻久痢",
    "腰膝酸软，畏寒肢冷",
  ];
  private secondarySymptoms: string[] = [
    "面色淡白或苍白，或伴有面色萎黄，主要为“无华”",
    "面色晄白或苍白，或伴有浮肿、暗沉，或面色黧黑，主要为“白或暗，无血色”",
    "情绪低落、焦虑不安",
    "口淡不渴或口苦咽干，不喜冷食，脘腹或小腹冷痛，口疮色淡",
    "动易疲劳，有气无力",
    "小便清长，或夜尿增多，或频多，或短少，或小便黄、淋沥不畅；耳鸣耳聋，发槁齿摇，男子性欲减退，或阳痿，女子宫冷不孕或带下清稀",
  ];
  private selectedMainSymptoms: string[] = [];
  private selectedSecondarySymptoms: string[] = [];
  private syndromeResultType: string = "";
  private syndromeResultOtherText: string = "";
  private ifShowBatchPrinting: boolean = false;
  private selectedIds: any[] = [];
  private diseaseName: string = "艾滋病免疫重建不全";
  private diseaseKey: string = "aizibing_mianyi_zhongjian_buquan";
  private checkId: string = "";
  private checkStartTime: string = "";
  private checkEndTime: string = "";

  private get patient() {
    return this.$store.state.patient;
  }

  private get tongueScores() {
    const text = this.getAllResultText();
    const feipiRules = [
      ["淡红", "淡白"],
      ["胖", "有齿痕"],
      ["白"],
      ["薄", "无"],
    ];
    const pishenRules = [
      ["红", "绛"],
      ["非胖"],
      ["非白"],
    ];
    let feipi = 0;
    feipiRules.forEach((group) => {
      const matched = group.some((k) => text.includes(k));
      if (matched) feipi += 10;
    });
    let pishen = 0;
    pishenRules.forEach((group) => {
      const matched = group.some((k) => text.includes(k));
      if (matched) pishen += 10;
    });
    return { feipi, pishen };
  }

  private get symptomScores() {
    const mainIdx = this.selectedMainSymptoms
      .map((t) => this.mainSymptoms.indexOf(t) + 1)
      .filter((n) => n > 0);
    const secIdx = this.selectedSecondarySymptoms
      .map((t) => this.secondarySymptoms.indexOf(t) + 1)
      .filter((n) => n > 0);

    // 肺脾气虚证：
    // 主症 1/2/3 每项10分；若2和3都选中，主症直接30分
    const feipiMainHitCount = mainIdx.filter((n) => [1, 2, 3].includes(n)).length;
    let feipiMain = feipiMainHitCount * 10;
    if (mainIdx.includes(2) && mainIdx.includes(3)) {
      feipiMain = 30;
    }
    // 主症最多30分
    feipiMain = Math.min(feipiMain, 30);
    // 次症 1/3/5 每项4分
    const feipiSec = secIdx.filter((n) => [1, 3, 5].includes(n)).length * 4;

    // 脾肾阳虚证：
    // 主症 3/4/5 每项10分；若4和6或5和6都选中，主症直接30分
    const pishenMainHitCount = mainIdx.filter((n) => [3, 4, 5].includes(n)).length;
    let pishenMain = pishenMainHitCount * 10;
    if ((mainIdx.includes(4) && mainIdx.includes(6)) || (mainIdx.includes(5) && mainIdx.includes(6))) {
      pishenMain = 30;
    }
    // 主症最多30分
    pishenMain = Math.min(pishenMain, 30);
    // 次症 2/4/6 每项4分
    const pishenSec = secIdx.filter((n) => [2, 4, 6].includes(n)).length * 4;

    return {
      feipi: feipiMain + feipiSec,
      pishen: pishenMain + pishenSec,
    };
  }

  private get scoreDetail() {
    const mainIdx = this.selectedMainSymptoms
      .map((t) => this.mainSymptoms.indexOf(t) + 1)
      .filter((n) => n > 0);
    const secIdx = this.selectedSecondarySymptoms
      .map((t) => this.secondarySymptoms.indexOf(t) + 1)
      .filter((n) => n > 0);

    const feipiMainHits = mainIdx.filter((n) => [1, 2, 3].includes(n));
    const feipiMainScore = (mainIdx.includes(2) && mainIdx.includes(3))
      ? 30
      : Math.min(feipiMainHits.length * 10, 30);
    const feipiSecHits = secIdx.filter((n) => [1, 3, 5].includes(n));
    const feipiSecScore = feipiSecHits.length * 4;

    const pishenMainHits = mainIdx.filter((n) => [3, 4, 5].includes(n));
    const pishenMainScore = ((mainIdx.includes(4) && mainIdx.includes(6)) || (mainIdx.includes(5) && mainIdx.includes(6)))
      ? 30
      : Math.min(pishenMainHits.length * 10, 30);
    const pishenSecHits = secIdx.filter((n) => [2, 4, 6].includes(n));
    const pishenSecScore = pishenSecHits.length * 4;

    const toText = (arr: number[]) => (arr.length ? arr.join("、") : "无");
    return {
      feipi: {
        mainHitsText: toText(feipiMainHits),
        mainScore: feipiMainScore,
        secHitsText: toText(feipiSecHits),
        secScore: feipiSecScore,
      },
      pishen: {
        mainHitsText: toText(pishenMainHits),
        mainScore: pishenMainScore,
        secHitsText: toText(pishenSecHits),
        secScore: pishenSecScore,
      },
    };
  }

  private get finalScores() {
    return {
      feipi: this.tongueScores.feipi + this.symptomScores.feipi,
      pishen: this.tongueScores.pishen + this.symptomScores.pishen,
    };
  }

  private get hasShemianmaiData() {
    return !!(this.shemianmai.she || this.shemianmai.shexia || this.shemianmai.mian || this.shemianmai.mai);
  }

  private get hasMainPicked() {
    return this.selectedMainSymptoms.length > 0;
  }

  private get hasSecondaryPicked() {
    return this.selectedSecondarySymptoms.length > 0;
  }

  private get canShowResultSection() {
    return this.hasShemianmaiData && this.hasMainPicked && this.hasSecondaryPicked;
  }

  private get autoResultType() {
    if (!this.canShowResultSection) {
      return "";
    }
    if (this.finalScores.feipi >= this.finalScores.pishen) {
      return "肺脾气虚证";
    }
    return "脾肾阳虚证";
  }

  private get syndromeResultTypeModel() {
    if (!this.syndromeResultType) {
      return this.autoResultType;
    }
    return this.syndromeResultType;
  }

  private get recommendedFormula() {
    const result = this.syndromeResultTypeModel;
    if (result === "脾肾阳虚证") {
      return "扶阳解毒颗粒";
    }
    if (result === "肺脾气虚证") {
      return "芪苓益气片";
    }
    return "";
  }

  private set syndromeResultTypeModel(val: string) {
    this.syndromeResultType = val;
  }

  private mounted() {
    const fromQuery = this.$route.query.disease as string;
    if (fromQuery) {
      this.diseaseName = fromQuery;
    }
    const queryKey = this.$route.query.diseaseKey as string;
    if (queryKey) {
      this.diseaseKey = queryKey;
    }
    const queryCheckId = this.$route.query.checkId as string;
    if (queryCheckId) {
      this.checkId = queryCheckId;
    }
    const queryCheckStart = this.$route.query.checkStartTime as string;
    if (queryCheckStart) {
      this.checkStartTime = queryCheckStart;
    }
    const queryCheckEnd = this.$route.query.checkEndTime as string;
    if (queryCheckEnd) {
      this.checkEndTime = queryCheckEnd;
    }
    this.getShemianmaiData();
  }

  private async getShemianmaiData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    try {
      const params: any = {
        params: {
          patient_id: this.patient.id,
          related_type: "四诊客观化数据",
        },
      };
      const newstData = await GetNewsTems(this, params, loading);
      const sourceRaw = newstData?.data?.["四诊客观化数据"] || [];
      const source = this.filterByCheckRange(sourceRaw);
      this.shemianmai.she = this.getCurrentData(source, "舌");
      this.shemianmai.mian = this.getCurrentData(source, "面");
      this.shemianmai.shexia = this.getCurrentData(source, "舌下");
      this.shemianmai.mai = this.getCurrentData(source, "脉");
      this.refreshAutoResultType();
    } finally {
      loading.close();
    }
  }

  private filterByCheckRange(arr: any[]) {
    if (!Array.isArray(arr)) return [];
    const startTs = this.checkStartTime ? new Date(this.checkStartTime).getTime() : NaN;
    const endTs = this.checkEndTime ? new Date(this.checkEndTime).getTime() : NaN;
    if (Number.isNaN(startTs) || Number.isNaN(endTs)) {
      return arr;
    }
    return arr.filter((item: any) => {
      const timeRaw = item?.collect_time || item?.create_datetime;
      if (!timeRaw) return false;
      const ts = new Date(timeRaw).getTime();
      if (Number.isNaN(ts)) return false;
      return ts >= startTs && ts < endTs;
    });
  }

  private getCurrentData(arr: any[], name: string) {
    let list: any[] = [];
    if (name === "舌") {
      list = arr.filter((t: any) => t.name && t.name.startsWith("舌") && !t.name.startsWith("舌下"));
    } else if (name === "舌下") {
      list = arr.filter((t: any) => t.name && t.name.startsWith("舌下"));
    } else {
      list = arr.filter((t: any) => t.name && t.name.includes(name));
    }
    if (!list || list.length === 0) {
      return null;
    }
    const latest = list
      .filter((t: any) => !!t.content_id)
      .sort((a: any, b: any) => {
        const ta = new Date(a.collect_time || a.create_datetime || 0).getTime();
        const tb = new Date(b.collect_time || b.create_datetime || 0).getTime();
        return tb - ta;
      })[0];
    if (!latest) {
      return null;
    }
    return this.normalizeForFilter(latest, name);
  }

  private normalizeForFilter(item: any, name: string) {
    if (!item) return null;
    const next: any = { ...item };
    if (!next.template_data || !Array.isArray(next.template_data) || next.template_data.length === 0) {
      const typeMap: any = {
        舌: "舌象80",
        舌下: "舌底",
        面: "面象15",
        脉: "脉象6",
      };
      next.template_data = [{ type: typeMap[name] || "" }];
    }
    return next;
  }

  private toggleMainSymptom(item: string) {
    const idx = this.selectedMainSymptoms.indexOf(item);
    if (idx >= 0) {
      this.selectedMainSymptoms.splice(idx, 1);
      this.refreshAutoResultType();
      return;
    }
    if (this.selectedMainSymptoms.length >= 3) {
      this.$message.warning("主症最多选择3项");
      return;
    }
    this.selectedMainSymptoms.push(item);
    this.refreshAutoResultType();
  }

  private toggleSecondarySymptom(item: string) {
    const idx = this.selectedSecondarySymptoms.indexOf(item);
    if (idx >= 0) {
      this.selectedSecondarySymptoms.splice(idx, 1);
      this.refreshAutoResultType();
      return;
    }
    if (this.selectedSecondarySymptoms.length >= 3) {
      this.$message.warning("次症最多选择3项");
      return;
    }
    this.selectedSecondarySymptoms.push(item);
    this.refreshAutoResultType();
  }

  private refreshAutoResultType() {
    if (!this.canShowResultSection) {
      this.syndromeResultType = "";
      this.syndromeResultOtherText = "";
      return;
    }
    this.syndromeResultType = this.autoResultType;
    if (this.syndromeResultType !== "其它") {
      this.syndromeResultOtherText = "";
    }
  }

  private getAllResultText() {
    const she = this.formatByFilter(this.shemianmai.she);
    const shexia = this.formatByFilter(this.shemianmai.shexia);
    const mian = this.formatByFilter(this.shemianmai.mian);
    const mai = this.formatByFilter(this.shemianmai.mai);
    return [she, shexia, mian, mai].filter((v) => !!v && v !== "/").join("；");
  }

  private formatByFilter(item: any) {
    if (!item || !item.report) return "";
    try {
      const type = item.template_data ? item.template_data[0].type : item.data[0].type;
      let str = "";
      if (type === "舌象80" && item.report["舌象信息"]) {
        const keys = ["舌神", "舌色", "舌形", "舌态", "苔质", "苔色"];
        const d: any = item.report["舌象信息"];
        keys.forEach((k) => {
          if (d[k] && d[k].length > 0) {
            const part = ([] as any[]).concat(d[k][0] || [], d[k][1] || []).filter(Boolean).join("、");
            if (part) {
              if (str) str += "；";
              str += `${k}：${part}`;
            }
          }
        });
      } else if (type === "舌底" && item.report["舌底信息"]) {
        const keys = ["长度", "形态", "颜色", "粗细"];
        const d: any = item.report["舌底信息"];
        keys.forEach((k) => {
          if (d[k]) {
            if (str) str += "；";
            str += `${k}：${d[k]}`;
          }
        });
      } else if (type === "面象15" && item.report["面象信息"]) {
        const keys = ["面色", "唇态", "唇色", "鼻光泽", "鼻形态", "鼻颜色", "人中形态", "人中颜色"];
        const d: any = item.report["面象信息"];
        keys.forEach((k) => {
          if (d[k] && d[k].length > 0) {
            if (str) str += "；";
            str += `${k}：${d[k].join("、")}`;
          }
        });
      } else if (type === "脉象6" && item.report["脉象信息输出"] && item.report["脉象信息输出"]["脉名"]) {
        const pos = `${item.report.pulse_hand || ""}${item.report.pulse_pos || ""}`;
        str = `${pos}：${item.report["脉象信息输出"]["脉名"]}`;
      }
      return str || "";
    } catch (e) {
      return "";
    }
  }

  private goReport(name: string) {
    const map: any = {
      舌: this.shemianmai.she,
      舌下: this.shemianmai.shexia,
      面: this.shemianmai.mian,
      脉: this.shemianmai.mai,
    };
    const item = map[name];
    if (!item || !item.content_id) {
      return;
    }
    this.$router.push({
      path: "/main/report/ceping-report",
      query: {
        ids: JSON.stringify([item.content_id]),
        ifShowFengmian: "否",
      },
    });
  }

  private goBack() {
    this.$router.back();
  }

  private async save(showMessage: boolean = true) {
    const payload = {
      shemianmai: this.shemianmai,
      selectedMainSymptoms: this.selectedMainSymptoms,
      selectedSecondarySymptoms: this.selectedSecondarySymptoms,
      tongueScores: this.tongueScores,
      symptomScores: this.symptomScores,
      scoreDetail: this.scoreDetail,
      finalScores: this.finalScores,
      syndromeResultType: this.syndromeResultTypeModel,
      recommendedFormula: this.recommendedFormula,
      syndromeResultOtherText: this.syndromeResultOtherText,
      savedAt: Date.now(),
    };
    try {
      await upsertZhuanbingModule(this, {
        patientId: this.patient.id,
        diseaseName: this.diseaseName,
        diseaseKey: this.diseaseKey,
        checkId: this.checkId,
        moduleKey: "bianzheng",
        moduleData: payload,
        loadingText: "保存专病辨证分析…",
      });
      if (showMessage) {
        this.$message.success("保存成功");
      }
    } catch (e: any) {
      const msg = e?.message || "保存失败，请稍后重试";
      this.$message.error(msg);
      throw e;
    }
  }

  private async goPrint() {
    await this.save(false);
    this.$nextTick(() => {
      window.print();
    });
  }
}
